import { PeopleEmployeeDto } from './people-employee.dto';

export class PeopleEmployeeNextOfKinDto {
  id?: number;
  employeeId?: number;
  nextOfKinName?: string;
  nextOfKinRelationship?: string;
  nextOfKinPhoneNumber?: string;
  nextOfKinAddress?: string;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;

  employee?: PeopleEmployeeDto;
}
